<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import SearchBar from '@/components/SearchBar/SearchBar.vue';
import { isPlatformIs24 } from '@/helpers/Platform/platform';

const { t } = useI18n();
const { locationsForSeo } = defineProps<{ locationsForSeo: string }>();
</script>

<template>
  <div :class="[$style.heroBannerWrapper, { [$style.is24Wrapper]: isPlatformIs24() }]">
    <div :class="$style.heroText">
      <div class="layout-container">
        <h1>{{ t('headingLocationSpecific', { location: locationsForSeo }) }}</h1>
        <p>{{ t('subHeading') }}</p>
        <SearchBar />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.heroBannerWrapper {
  padding: $space-150 $space-200 $space-200;
  background-color: $color-orange-0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &.is24Wrapper {
    background-color: $color-grey-30;
  }
}

.heroText {
  h1 {
    @include heading-1;
  }

  p {
    margin-top: $space-50;
    color: $color-grey-100;

    @include body-2;
  }
}
</style>
